export const SET_DARKMODE_BG = 'SET_DARKMODE_BG';
export const SET_DARKMODE_THEME = 'SET_DARKMODE_THEME';
export const SET_LIGHTMODE_THEME = 'SET_LIGHTMODE_THEME';
export const SAVE_FIREBASE_SETTINGS = 'SAVE_FIREBASE_SETTINGS';
export const GET_FIREBASE_SETTINGS = 'GET_FIREBASE_SETTINGS';
export const RESET_THEME_SETTINGS = 'RESET_THEME_SETTINGS';
export const LOADING_FIREBASE_SETTINGS = 'LOADING_FIREBASE_SETTINGS';
export const SET_LANGUAGE = 'SET_LANGUAGE';
